import { useEffect } from 'react'
import UserEventApi from '../api/UserEventApi'
import { EntityType } from '../types/EntityType'
import useAuth from './useAuth'
import { USER_EVENT_TYPES, UserEventType } from '@finance-lab/utils/types'

const entityTypeToUserEvent: Record<EntityType, UserEventType> = {
    issue: USER_EVENT_TYPES.SHOW_ALL_ISSUES,
    company: USER_EVENT_TYPES.SHOW_ALL_COMPANIES,
    news: USER_EVENT_TYPES.SHOW_ALL_NEWS,
    warrant: USER_EVENT_TYPES.SHOW_ALL_WARRANTS,
    convertible: USER_EVENT_TYPES.SHOW_ALL_CONVERTIBLES,
}
const api = new UserEventApi()

const isEntityType = (val: EntityType | UserEventType): val is EntityType => val in entityTypeToUserEvent

export const useLogUserEvent = (entityType: EntityType | UserEventType, eventDetails: Record<string, unknown> = {}) => {
    const { isAuthenticated } = useAuth()
    const eventDetailsStr = JSON.stringify(eventDetails) // Stringify to be used in useEffect

    useEffect(() => {
        if (!isAuthenticated) return

        if (entityType) {
            void (async () => {
                const eventName = isEntityType(entityType) ? entityTypeToUserEvent[entityType] : entityType

                await api.logEvent(eventName, JSON.parse(eventDetailsStr))
            })()
        }
    }, [entityType, eventDetailsStr, isAuthenticated])
}
